module.exports = __webpack_public_path__ + "static/media/img27.31a7389b.jpg";